// extracted by mini-css-extract-plugin
export default {"selectImgs":"select_selectImgs__wuwVo","imageContainer":"select_imageContainer__5VYQ-"};